import { render, staticRenderFns } from "./LocationsFilters.vue?vue&type=template&id=bada8bf2&scoped=true"
import script from "./LocationsFilters.vue?vue&type=script&lang=js"
export * from "./LocationsFilters.vue?vue&type=script&lang=js"
import style0 from "./LocationsFilters.vue?vue&type=style&index=0&id=bada8bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bada8bf2",
  null
  
)

export default component.exports